const RESUME_NOTICE_EVENT = 'rastyle:resume-notice';
const RESUME_NOTICE_ACTION_EVENT = 'rastyle:resume-notice-action';
const DEFAULT_NOTICE_DURATION_MS = 5000;

const formatResumePosition = (seconds = 0, unit = 'seconds') => {
  const value = Math.max(0, Number(seconds) || 0);
  if (unit === 'pixels') return null;
  const total = Math.floor(value);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  if (hours > 0) return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  return `${minutes}:${String(secs).padStart(2, '0')}`;
};

const buildResumeNotice = ({ entity, position = 0, unit = 'seconds', anchor = null, kind = null } = {}) => {
  if (!entity?.id) return null;
  const resolvedKind = kind || (entity.type === 'article' ? 'reading' : entity.type === 'video' ? 'watching' : 'listening');
  const formatted = formatResumePosition(position, unit);
  const message = resolvedKind === 'reading'
    ? 'Continued where you left off'
    : `Resuming from ${formatted || 'your saved position'}`;
  return {
    id: `${entity.type || 'content'}:${entity.id}`,
    entity,
    kind: resolvedKind,
    position: Math.max(0, Number(position) || 0),
    unit,
    anchor,
    message,
    canStartOver: true,
    durationMs: DEFAULT_NOTICE_DURATION_MS,
  };
};

const emitResumeNotice = (payload, target = globalThis.window) => {
  const notice = buildResumeNotice(payload);
  if (!notice || !target?.dispatchEvent || typeof CustomEvent === 'undefined') return null;
  target.dispatchEvent(new CustomEvent(RESUME_NOTICE_EVENT, { detail: notice }));
  return notice;
};

const emitResumeNoticeAction = ({ notice, action }, target = globalThis.window) => {
  if (!notice?.id || !action || !target?.dispatchEvent || typeof CustomEvent === 'undefined') return false;
  target.dispatchEvent(new CustomEvent(RESUME_NOTICE_ACTION_EVENT, { detail: { notice, action } }));
  return true;
};

export {
  DEFAULT_NOTICE_DURATION_MS,
  RESUME_NOTICE_ACTION_EVENT,
  RESUME_NOTICE_EVENT,
  buildResumeNotice,
  emitResumeNotice,
  emitResumeNoticeAction,
  formatResumePosition,
};
